export default "__VITE_ASSET__EC1$AkPd__"